import Flickity from 'flickity';
import { gsap, ScrollTrigger, lenis } from '../global/gsap';

// Matches the sticky offset on .flex-featured__content
const scrollOffset = -40;
const fadeDuration = 0.2;

const initFlexFeatured = (elements) => {
    elements.forEach((element) => {
        const dots = [...element.querySelectorAll('.js-featured-dot')];
        const prev = element.querySelector('.js-featured-prev');
        const next = element.querySelector('.js-featured-next');
        const mediaGroups = [...element.querySelectorAll('.js-featured-media')];

        const panel = element.querySelector('.js-featured-content');
        const number = element.querySelector('.js-featured-number');
        const count = element.querySelector('.js-featured-count');
        const title = element.querySelector('.js-featured-title');
        const subtitle = element.querySelector('.js-featured-subtitle');
        const text = element.querySelector('.js-featured-text');

        if (mediaGroups.length === 0) {
            return;
        }

        // The count sits outside the panel, so both fade together
        const fadeTargets = [panel, count].filter(Boolean);

        const sliders = [];

        let active = null;
        let fade;

        const setContent = (group, index, animate = true) => {
            const applyContent = () => {
                if (number) {
                    number.textContent = `${index + 1}.`;
                }

                if (count) {
                    count.textContent = `${index + 1}/${mediaGroups.length}`;
                }

                if (title) {
                    title.textContent = group.dataset.title || '';
                }

                if (subtitle) {
                    subtitle.textContent = group.dataset.subtitle || '';
                }

                if (text) {
                    text.innerHTML = group.dataset.text || '';
                }
            };

            if (!animate || fadeTargets.length === 0) {
                applyContent();
                return;
            }

            // Restart from wherever a previous fade got to, so fast
            // scrolling between groups doesn't stack timelines
            if (fade) {
                fade.kill();
            }

            fade = gsap
                .timeline()
                .to(fadeTargets, {
                    opacity: 0,
                    duration: fadeDuration,
                    ease: 'power1.out',
                    onComplete: applyContent
                })
                .to(fadeTargets, {
                    opacity: 1,
                    duration: fadeDuration,
                    ease: 'power1.in'
                });
        };

        const setActive = (index, animate = true) => {
            // The first and last groups toggle back to active without
            // anything in between, so ignore anything but a real change
            if (index === active) {
                return;
            }

            active = index;

            setContent(mediaGroups[index], index, animate);

            dots.forEach((dot, dotIndex) => {
                dot.classList.toggle('active', dotIndex === index);
            });

            if (prev) {
                prev.disabled = index === 0;
            }

            if (next) {
                next.disabled = index === mediaGroups.length - 1;
            }
        };

        const scrollToGroup = (index) => {
            if (index < 0 || index > mediaGroups.length - 1) {
                return;
            }

            lenis.scrollTo(mediaGroups[index], {
                offset: scrollOffset,
                duration: 1
            });
        };

        // A group is active while its top has passed the middle of the viewport
        mediaGroups.forEach((group, index) => {
            ScrollTrigger.create({
                trigger: group,
                invalidateOnRefresh: true,
                start: 'top center',
                end: 'bottom center',
                onToggle: (self) => {
                    if (self.isActive) {
                        setActive(index);
                    }
                }
            });

            sliders.push(
                new Flickity(group, {
                    cellAlign: 'left',
                    contain: true,
                    prevNextButtons: false,
                    pageDots: false,
                    draggable: true,
                    watchCSS: true
                })
            );
        });

        if (prev) {
            prev.addEventListener('click', () => scrollToGroup(active - 1));
        }

        if (next) {
            next.addEventListener('click', () => scrollToGroup(active + 1));
        }

        setActive(0, false);
    });
};

export { initFlexFeatured as default };
